import { render, staticRenderFns } from "./WalletOpenerBanner.vue?vue&type=template&id=c8785ed4"
import script from "./WalletOpenerBanner.vue?vue&type=script&lang=js"
export * from "./WalletOpenerBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports